export default __webpack_public_path__ + "static/media/cp_ms_office365.385bf055.svg";